import {  Response }   from '@angular/http';
import { Observable } from 'rxjs';

export class ServiceUtil {

  // extrai lista da resposta http
  public extractData(res: any) {
    let body = res;
    return body.data || { };
  }

  // manipula erros da resposta http
  public handleError(err: Response | any):Observable<any> {
    let errMsg: string;
    if (err && err.error && err.error.message) {
      // A client-side or network error occurred. Handle it accordingly.
      errMsg = err.error.message;
    }else if(err && err.error && err.error.err.error) {
      // The backend returned an unsuccessful resptatus}, body was: ${err.error.error}`);
      errMsg = err.error.error;
      if(errMsg === "eunavailable_service"){
        errMsg= "ERRO: Servidor de Dados Indisponível";
      }
    }else{
      errMsg = err;
       errMsg= err + "ERRO: Servidor de Dados Indisponível";
    }

    return Observable.throw(errMsg);
  }



}
